import { ObjectDrawerParameters } from '../component-library/object-drawer/object-drawer-parameters';

export class EventParameters extends ObjectDrawerParameters {
  public onlyUser: boolean = false;
  public onlyActive: boolean = false;
  public username: string = '';
}
